<script setup lang="ts">

import { FeatureFrame } from "../Components";
import type { IGenericFeature } from "@domain/CarePlan";

const model = defineModel<IGenericFeature>( { required: true } ); 

</script>

<template>

    <!-- Warranty -->
    <FeatureFrame>

        <template #title>{{ model.title }}</template>
        <template #sub-title>You have a Mechanical Protection plan</template>

        <div class="flex flex-col w-full">

        </div>

   </FeatureFrame>
        
</template>
